import React from "react";
import TabOfDataTable from "../../../Elements/DataTable/TabOfDataTable";
import EvaluatorPaymentService from "../../../Services/EvaluatorPaymentService";
import OrderDirectionsEnum from "../../../Enums/OrderDirectionsEnum";
import ShownPanelsEnum from "../../../Enums/ShownPanelsEnum";
import VoidedPaymentsAdminSearchParams from "./VoidedPaymentsAdminSearchParams";
import VoidedPaymentAdminItem from "../../../Domain/ThirdParty/ThirdPartyJobPayments/VoidedPaymentAdminItem";
import EvaluatorPaymentActionParamsItem from "../../Evaluator/EvaluatorAdmin/EvaluatorPayments/EvaluatorPaymentActionParamsItem";
import GeneralEditWizzardBase from "../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma";
import CrudTypesEnum from "../../../Enums/CrudTypesEnum";
import VoidWindowDescription from "../../Evaluator/EvaluatorAdmin/EvaluatorPayments/VoidWindowDescription";
import VoidAndReissueWindowDescription from "../../Evaluator/EvaluatorAdmin/EvaluatorPayments/VoidAndReissueWindowDescription";
import VoidAndSupressWindowDescription from "../../Evaluator/EvaluatorAdmin/EvaluatorPayments/VoidAndSupressWindowDescription";
import ApproveWindowDescription from "../../Evaluator/EvaluatorAdmin/EvaluatorPayments/ApproveWindowDescription";
import EvaluatorPaymentItem from "../../../Domain/EvaluatorPaymentItem";

export default class VoidedPaymentsAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new VoidedPaymentsAdminSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      allItemsInTheSearchSetAreSelected: false,
      popup: null,
    };

    this.startSearch = this.startSearch.bind(this);
    EvaluatorPaymentItem.actionFunction = this.clickOnAction.bind(this);
  }

  clickOnAction(ieIds, actionType) {
    let windowDescription = null;
    switch (actionType) {
      case "Void":
        windowDescription = VoidWindowDescription;
        break;
      case "VoidAndReissue":
        windowDescription = VoidAndReissueWindowDescription;
        break;
      case "VoidAndSupress":
        windowDescription = VoidAndSupressWindowDescription;
        break;
      default:
        windowDescription = ApproveWindowDescription;
    }

    const paramsData = new EvaluatorPaymentActionParamsItem(ieIds, this.state.allItemsInTheSearchSetAreSelected, this.state.searchItem);

    this.setState({
      popup: (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={paramsData}
          clickOnCancel={() => this.setState({ popup: null })}
          clickOnSave={() => this.setState({ popup: null })}
          windowDescription={windowDescription}
        />
      ),
    });
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  render() {
    return (
      <div className="contentwrapper">
        {this.state.popup}
        <TabOfDataTable
          type={VoidedPaymentAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorPaymentService.GetEvaluatorPayments}
          convertDBItemsFunction={EvaluatorPaymentService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy="AsEvname"
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={VoidedPaymentsAdminSearchParams}
          enableUrlPush={false}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder="Search in Evaluators or Pay IDs..."
        />
      </div>
    );
  }
}
